import { BaseAPI } from "./base-api";

class FmsReportsAPI extends BaseAPI {
  constructor() {
    super();
  }

  async getLocations() {
    const response = await this.axiosInstance.get("/api/fms-report/locations");
    return response.data;
  }

  async getReportDownloadUrl({
    locationId,
    reportType,
    reportStartDate,
    reportEndDate,
  }: {
    locationId: number;
    reportType: string;
    reportStartDate: string;
    reportEndDate: string;
  }) {
    const response = await this.axiosInstance.get("/api/fms-report/download-url", {
      params: { locationId, reportType, reportStartDate, reportEndDate },
    });
    return response.data;
  }
}

export const fmsReportsApi = new FmsReportsAPI();
